import * as React from "react";

interface ValidateErrorProps {
  className?: string;
  text?: string;
}

export default class ValidateError extends React.Component<
  ValidateErrorProps,
  any
> {
  public static defaultProps = {
    className: "form-control",
    text: "This field is required",
  };

  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className={`${this.props.className}__error-msg`}>
        <span className={`${this.props.className}__error-msg__text`}>
          {this.props.text}
        </span>
      </div>
    );
  }
}
